import React, { useEffect, useState } from "react";
import {
    WorkTimeFormOptionsMapping,
    useWorkTimeFormOptions,
} from "../../hooks/worktime/useWorkTimeFormOptions";
import { WorkTimeStartForm } from "./workTimeStartForm";
import { IWorkTimeStartFormItem } from "../../models/workShiftTimeSlot/workTimeStartFormItem";
import { useSelectCurrentWorkShiftTimeSlot } from "../../hooks/worktime/useSelectWorkShiftTimeSlots";
import { useLocation } from "react-router-dom";
import { HourBookingCategory } from "../../models/workHours/workHoursItem";

export const WorkTimeStart = () => {
    const [formOptions, ready] = useWorkTimeFormOptions(
        [
            WorkTimeFormOptionsMapping.vehicles.attr,
            WorkTimeFormOptionsMapping.salaryRowTypes.attr,
            WorkTimeFormOptionsMapping.costCenters.attr,
            WorkTimeFormOptionsMapping.allCostCenters.attr,
            WorkTimeFormOptionsMapping.customers.attr,
        ],
        [
            HourBookingCategory.CustomNormalType,
            HourBookingCategory.CustomAddition,
        ]
    );
    const current = useSelectCurrentWorkShiftTimeSlot();
    const [item, setItem] = useState<IWorkTimeStartFormItem>(current);
    const location = useLocation();

    const { plan } = location.state ?? {};

    useEffect(() => {
        if (item) {
            return;
        }

        const newItem: IWorkTimeStartFormItem = {
            customerId: null,
            costCenterId: null,
            workTimeTypeId: null,
            vehicleId: null,
            salaryRowTypeId: null,
        };

        if (plan?.vehicle) {
            newItem.vehicleId = plan.vehicle.id;
        }

        setItem(newItem);
    }, [plan]);

    return ready && item ? (
        <WorkTimeStartForm item={item} formOptions={formOptions} />
    ) : null;
};
